import React, { useEffect, useState } from "react";
import {
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Divider,
    Box,
    IconButton
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import authService from "../../Auth/AuthService";
import { Edit } from "@mui/icons-material";
import MarksheetForm from "./MarksheetForm";
import ModalView from "../../model/ModelView";

const MarksView = ({ marksheets, room, onSuccess }) => {
    const navigate = useNavigate();
    const tokenInfo = authService.tokenInfo();
    const [markForm, setMarkForm] = useState(false);
    const [selectedMark, setSelectedMark] = useState([]);
    const DOC_URL = authService.DOC_URL;

    const handlePrint = async (marksheet) => {
        const url1 = authService.pathUrl('GET', '/schools/' + tokenInfo?.mas_id)
        const resSch = await authService.getAuth(url1);

        const data = [{
            logo: DOC_URL + resSch?.logoUrl,
            schoolName: resSch?.schoolName,
            address: [resSch?.addressLine1, resSch?.city, resSch?.state]
                .filter(Boolean) // removes null/undefined/empty
                .join(", "),
            studentName: [room?.name || marksheet?.studentName, room?.father, room?.last].filter(Boolean).join(" "),
            receiptNumber: marksheet?.classRoom?.classId, //resFee?.id,
            ...marksheet,
        }];
        sessionStorage.setItem("hide", false);

        navigate('/marksheet-receipt', {
            state: {
                receiptData: data
            },
        });
    };
    const handleClose = () => {
        setMarkForm(false);
    }
    const handleEdit = (marksheet) => {
        setMarkForm(true);
        setSelectedMark([marksheet]);
        // if (onSuccess) onSuccess();
    }

    return (
        <Box >
            {Array.isArray(marksheets) && marksheets?.map((marksheet, index) => (
                <Paper key={marksheet?.id} sx={{ p: 1, mb: 1 }} elevation={4}>
                    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'flex-start'} >
                        <Box>
                            <Typography><b>Student Name:</b> {room?.name} {room?.father} {room?.last}</Typography>
                            <Typography variant="subtitle1"><b>Standard: </b>{marksheet?.classRoom?.standard} | Section: {marksheet?.classRoom?.section}</Typography>
                            <Typography variant="subtitle1">Exam: {marksheet?.examType} | Academic Year: {marksheet?.academicYear}</Typography>
                        </Box>
                        {tokenInfo?.roles === 'ADMIN' && marksheet?.status !== "N" && (
                            <IconButton
                                color="warning"
                                onClick={() => { handleEdit(marksheet) }}
                                title="Edit Mark Entry">
                                <Edit sx={{ border: "1px solid", fontWeight: "bold", borderRadius: "4px" }} />
                            </IconButton>
                        )}
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ background: "#b9d8f7ff" }}>
                                <TableCell>Subject</TableCell>
                                <TableCell>Marks Obtained</TableCell>
                                <TableCell>Max Marks</TableCell>
                                <TableCell>Grade</TableCell>
                                <TableCell>Remarks</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {marksheet?.marks.map((m) => (
                                <TableRow key={m.id}>
                                    <TableCell>{m.subjectName}</TableCell>
                                    <TableCell>{m.marksObtained}</TableCell>
                                    <TableCell>{m.maxMark}</TableCell>
                                    <TableCell>{m.grade}</TableCell>
                                    <TableCell>{m.remark}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <Typography variant="body1" sx={{ mt: 2 }}>
                        <strong>Total Marks:</strong> {marksheet.totalMarks} |{" "}
                        <strong>Percentage:</strong> {marksheet.percentage.toFixed(2)}% |{" "}
                        <strong>Grade:</strong> {marksheet.grade}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Remarks: {marksheet.remarks}
                    </Typography>
                    {tokenInfo.is_permited?.Marksheet && (
                        <Box textAlign="center" mt={3}>
                            <Button variant="contained" sx={{ bgcolor: "#3f2d01", borderRadius: 5 }} onClick={() => handlePrint(marksheet)}>
                                Generate Marksheet
                            </Button>
                        </Box>
                    )}
                </Paper>
            ))}

            <ModalView size={'md'}
                open={markForm}
                handleClose={handleClose}
                title={marksheets ? "Update Marks" : "Add Marks"}
                content={<MarksheetForm
                    marksheets={selectedMark}
                    classRoomid={selectedMark?.id}
                    onSuccess={() => {
                        setMarkForm(false);
                        if (onSuccess) onSuccess();
                    }}
                />}
            />
        </Box>
    );
};

export default MarksView;
